import { ButtonColors } from 'types';
import { Flex } from 'components/flex';
import { Row, Col } from 'components/grid';
import { InputField } from 'components/fields';
import { Dialog, DialogType } from 'components/dialog';
import { Button, ButtonWithRef } from 'components/button';

import { RefundDialogProps } from './types';

export const RefundExchangeDialog = ({
  ownPin,
  disabled,
  onConfirm,
  isExchange,
  hideManagerPin,
}: RefundDialogProps) => (
  <Dialog
    title={`Accept ${isExchange ? 'Exchange' : 'Refund'}`}
    trigger={
      <ButtonWithRef
        disabled={disabled}
        text={`Confirm ${isExchange ? 'Exchange' : 'Refund'}`}
      />
    }
  >
    {(close, _, ButtonWrap) => (
      <Flex column gap={8} fullWidth>
        <div>
          Are you sure you want to make a {isExchange ? 'exchange' : 'refund'}{' '}
          on this order? This action cannot be cancelled
        </div>

        {!hideManagerPin && (
          <Row>
            <Col>
              <InputField
                number
                autofill="off"
                name="approvalPassword"
                autoComplete="one-time-code"
                label={
                  ownPin && !isExchange ? 'Your approval PIN' : 'Manager PIN'
                }
                placeholder={
                  ownPin && !isExchange
                    ? "Yours or the show manager's"
                    : 'Manager PIN'
                }
              />
            </Col>
          </Row>
        )}

        <ButtonWrap type={DialogType.Plain}>
          <Button
            text="Cancel"
            onClick={close}
            colorType={ButtonColors.LightBlue}
          />
          <Button
            text="Accept"
            colorType={ButtonColors.LightGreen}
            onClick={() => {
              onConfirm();
              close();
            }}
          />
        </ButtonWrap>
      </Flex>
    )}
  </Dialog>
);
